import { render } from "./DriftBottleTypesList.vue?vue&type=template&id=4c896628"
import script from "./DriftBottleTypesList.vue?vue&type=script&lang=js"
export * from "./DriftBottleTypesList.vue?vue&type=script&lang=js"

import "./DriftBottleTypesList.vue?vue&type=style&index=0&id=4c896628&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__